import styled from 'styled-components';
const BaseList = styled.ul `
  display: flex;
  box-sizing: border-box;
  border-bottom: 1px solid ${({ theme }) => theme.colors.ui05};

  li:not(:first-child) {
    margin-left: 24px;
  }

  button {
    background: transparent;
    border: none;
    padding: 0;
    padding-bottom: 20px;
    cursor: pointer;
  }
`;
const BaseListItem = styled.li `
  ${({ active, theme }) => active
    ? `
        border-bottom: 3px solid ${theme.colors.ui04}; 
    `
    : ''};
`;
export { BaseList, BaseListItem };
//# sourceMappingURL=BaseList.js.map